import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import SingleFileUpload from '../../Utilities/SingleFileUpload';
import { useContext, useEffect, useMemo, useState } from 'react';
import { APIContext } from '../../Contexts/APIContext';
import DropDownViewModel from '../../Utilities/ViewModels/DropDownViewModel';
import ValidatedSelectElement from '../../Utilities/Forms/ValidatedSelectElement';
import { FormContainer } from 'react-hook-form-mui';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { ReleaseVersion } from './ReleaseManagementTypes';

interface IProps {
    open: boolean;
    onClose: () => void;
}

export default function UploadSurveyDialog(props: IProps) {
    const { open, onClose } = props;
    const [file, setFile] = useState<File | null>(null);
    const [area, setArea] = useState<string>('');
    const [options, setOptions] = useState<DropDownViewModel[]>([]);
    const [versions, setVersions] = useState<ReleaseVersion[]>([]);
    const [versionId, setVersionId] = useState(0);
    const { post, get, showMessage } = useContext(APIContext)

    const futureVersions = useMemo(
        () => versions.filter(version => !version.isCurrent && new Date(version.start).getTime() > Date.now()),
        [versions]
    );

    useEffect(() => {
        if (!open) return;
        get('Admin', 'GetReleaseVersions', (items: ReleaseVersion[]) => {
            setVersions(items);
            // Versions are returned newest first, so default to the nearest future version (the last one)
            const future = items.filter(version => !version.isCurrent && new Date(version.start).getTime() > Date.now());
            setVersionId(future.length > 0 ? future[future.length - 1].id : 0);
        });
    }, [open]);

    useEffect(() => {
        get('SiteUploads', 'GetAreas', (e: DropDownViewModel[]) => {

            setOptions(e)
        });
    }, []);

    const onFileDrop = (newFile: File | null) => {
        setFile(newFile);
    }

    const onFileDelete = () => {
        setFile(null);
    }

    const uplodadFile = () => {
        if (file === null) return;

        const formData = new FormData();
        formData.append('file', file);
        post('SiteUploads', `UploadSite?area=${area}&versionId=${versionId}`, formData, () => {
            showMessage("success", "Site Uploaded successfully!");
            onClose();
        });
    }


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Upload Survey</DialogTitle>
            <DialogContent>
                <TextField select fullWidth label="Future data version" value={versionId} sx={{ mt: 1, mb: 2 }}
                    disabled={futureVersions.length === 0}
                    onChange={event => setVersionId(Number(event.target.value))}>
                    {futureVersions.map(version => <MenuItem key={version.id} value={version.id}>{version.versionName}</MenuItem>)}
                </TextField>
                {futureVersions.length === 0 && <Alert severity="warning" sx={{ mb: 2 }}>There are no future data versions available.</Alert>}
                <SingleFileUpload onDrop={onFileDrop} onDelete={onFileDelete} file={file} />
                {file !== null &&
                    <FormContainer>
                        <ValidatedSelectElement name={'test'} options={options} onChange={

                            (e: any) => setArea(e)
                        } />
                    </FormContainer>
                }
                <DialogActions>
                    <Button disabled={file === null || versionId <= 0} onClick={uplodadFile}>
                        Upload
                    </Button>
                    <Button onClick={() => onClose()}>
                        Cancel
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}